 
export const deviceTypes = {
    ANDROID: 'android',
    IPHONE: 'iphone'
}

export const mobileDeviceTypes = {
    [deviceTypes.IPHONE]: 'iPhone',
    [deviceTypes.ANDROID]: 'Android'
}
